export default function IconItem({ iconItem: Icon }) {
  return Icon && Icon;
}
